import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchWelcomePageHeroBannerAction } from './actions/fetchWelcomePageHeroBanner';

import {HeroBanner} from './welcomePageHeroBanner';

const mapStateToProps = (state: IState) => ({
    welcomePageHeroBanner: state.welcomePageContent.heroBanner
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchWelcomePageHeroBanner: () => dispatch(fetchWelcomePageHeroBannerAction())
});

export const WelcomePageHeroBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeroBanner);


// WEBPACK FOOTER //
// ./src/components/welcomePageHeroBanner/welcomePageHeroBannerContainer.tsx